<template>
    <div class="overflow-hidden-x provider-profile-layout">
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <h6 class="goto-search wl-color cursor-pointer" @click.prevent="gotoSearch"><i class="fas fa-arrow-circle-left wl-color"></i> Back to Search Results</h6>
                </div>
            </div>
            <provider-profile
                :providerEntityId="providerEntityId"
                @profile-ready="onProfileReady"
            />
            <div class="container-fluid profile-body">
                <div class="row" style="margin-top: .5rem;">
                    <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                        <plan-stack-skeleton v-if="!showPlansSection" />
                        <plans v-if="showPlansSection" :plans="filteredPlans" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import ProviderProfile from "../../../../components/shared/providerProfileAndPlans/ProviderProfile.vue";
    import {physcianPlansMixin} from "../../../../components/shared/mixins/physicianPlansMixin.js";
    import {mapGetters} from "vuex";
    import Plans from "../../../../components/shared/providerProfileAndPlans/Plans.vue";
    import PlanStackSkeleton from "../../../../components/shared/providerProfileAndPlans/PlanStackSkeleton.vue";
    import Plan from "../../../../components/shared/providers/plans/Plan.vue";
    import {common} from "../../../../global/common.js";
    import {planCategoryFilterMixin} from "../../../../components/shared/mixins/planCategoryFilterMixin.js";

    export default {
        name: "ProviderProfileLayout",
        props: {
            providerEntityId: {type: [Number], required: true},
            companyId: {type: [Number], required: true},
            token: {type: [String], required: true},
            planCategoryId: {type: [Number, String], default: null},
        },
        components: {Plan, Plans, PlanStackSkeleton, ProviderProfile},
        data() {
            return {
                plansDataReady: false,
                profileReady: false,
            };
        },
        mixins: [physcianPlansMixin, planCategoryFilterMixin],
        computed: {
            ...mapGetters({showPricing: "globalSettings/showPricing"}),
            filteredPlans() {
                return this.filterPlansByCategory(this.plans);
            },
            showPlansSection() {
                return this.plansDataReady && this.profileReady;
            },
        },
        watch: {
            showPlansSection(val) {
                if (val) {
                    this.$nextTick(() => this.addSlimScroll());
                }
            },
        },
        methods: {
            getCustomId(planName, planId) {
                let id = "";
                id = planName + "select" + planId;
                id = "p-" + id.replace(/\W/g, '-').toLowerCase();
                return id;
            },
            gotoSearch() {
                if (this.$route.name === 'providerProfile') {
                    common.goBack();
                    return;
                }
                this.$emit('back-to-search');
            },
            onProfileReady() {
                this.profileReady = true;
            },
        },
        async mounted() {
            let url = `ProviderSearch/${this.companyId}/getProviderPlansForCompany/${this.providerEntityId}`;
            url = common.appendUrlParameter(url, 'token', this.token);
            await this.baseInit(url, { deferSlimScroll: true });
            this.plansDataReady = true;
        }

    }
</script>

<style scoped>
    .goto-search {
        padding: 20px 10px 0 10px;
        text-transform: none;
        display: inline-block;
    }

    .background-white {
        background: #FFFFFF;
    }

    .profile-body {
        padding-right: 0;
    }

    .profile-body .select-button span {
        position: absolute;
        width: 100%;
        left: 0;
        bottom: 0;
        border-bottom-left-radius: 15px;
        border-bottom-right-radius: 15px;
        cursor: pointer;
        width: 100%;
        padding: 8px;
    }

    .profile-body .select-button span[aria-expanded="true"] {
        bottom: inherit;
        border-bottom-left-radius: 0;
        border-bottom-right-radius: 0;
        margin-top: 10px;
        background-color: rgba(0, 0, 0, .5) !important;
    }

    .overflow-hidden-x {
        overflow-x: hidden;
    }

    .provider-profile-layout {
        background-color: rgb(240, 239, 239);
        padding: 0;
        margin: 0;
    }

</style>